import styles from './Home.module.css';

interface HomeProps {
  onAddSpending?: () => void;
  onViewPayments?: () => void;
  onViewExpenses?: () => void;
  onAddIncome?: () => void;
  onHelp?: () => void;
}

export default function Home({
  onAddSpending,
  onViewPayments,
  onViewExpenses,
  onAddIncome,
  onHelp,
}: HomeProps) {
  return (
    <main className={styles.container}>
      <header className={styles.header}>
        <h1 className={styles.title}>HONAWICO</h1>
        <p className={styles.subtitle}>Property Tracker</p>
      </header>

      <nav className={styles.buttonGroup} aria-label="Main actions">
        <button
          className={styles.primaryButton}
          onClick={onAddSpending}
          aria-label="Add Spending — a receipt, a bill or any payment"
        >
          🧾 Add Spending
        </button>

        <button
          className={styles.primaryButton}
          onClick={onViewPayments}
          aria-label="View Payments — each payment, and who paid"
        >
          📋 View Payments
          <span className={styles.buttonSub}>Each payment, and who paid</span>
        </button>

        <button
          className={styles.primaryButton}
          onClick={onViewExpenses}
          aria-label="View Expenses — what each house has cost"
        >
          📒 View Expenses
          <span className={styles.buttonSub}>What each house has cost</span>
        </button>

        <button
          className={styles.primaryButton}
          onClick={onAddIncome}
          aria-label="Add income or rental revenue"
        >
          💵 Add Income
        </button>

        <button
          className={styles.helpButton}
          onClick={onHelp}
          aria-label="Help and user guide"
        >
          ❓ Help / Guide
        </button>
      </nav>
    </main>
  );
}
